var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { cssThemedValue, typographyCss } from '@creditornot/cb-ingredients';
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n"], ["\n  box-sizing: border-box;\n"])));
var Header = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  margin-bottom: 12px;\n"], ["\n  ", "\n  color: ", ";\n  margin-bottom: 12px;\n"])), typographyCss.Small, cssThemedValue('textSecondary'));
var Items = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  > [data-cb-menu-item] {\n    width: calc(100% + 16px);\n    margin-inline-start: -8px;\n  }\n\n  > * + * {\n    margin-top: 8px;\n  }\n"], ["\n  > [data-cb-menu-item] {\n    width: calc(100% + 16px);\n    margin-inline-start: -8px;\n  }\n\n  > * + * {\n    margin-top: 8px;\n  }\n"])));
var MenuItemGroup = forwardRef(function (_a, ref) {
    var children = _a.children, title = _a.title, rest = __rest(_a, ["children", "title"]);
    return (React.createElement(Root, __assign({}, rest, { ref: ref, "data-cb-menu-item": true }),
        !!title && React.createElement(Header, null, title),
        React.createElement(Items, null, children)));
});
MenuItemGroup.displayName = 'MenuItemGroup';
export default MenuItemGroup;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=MenuItemGroup.js.map